import '@babel/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import Framework7 from 'framework7/framework7.esm.bundle.js';
import Framework7React, { App, View, Statusbar } from 'framework7-react';
import routes from './routes';
import config from './config';

import './scss/app.scss';

const f7params = {
  name: 'BanaBi Webview',
  id: 'com.banabi',
  theme: 'auto',
  routes: routes,
  data: {
    services: config[process.env.REACT_APP_API_ENV || process.env.NODE_ENV].services,
  },
  view: {
    pushState: true,
    pushStateSeparator: '',
  },
};

const ReactApp = () => (
  <App params={f7params}>
    <Statusbar />
    <View main />
  </App>
);

Framework7.use(Framework7React);

ReactDOM.render(React.createElement(ReactApp), document.getElementById('app'));
